import React, { useEffect } from 'react';
import { RoutePaths } from './Constants/Common';
import './App.scss';
import Auth0ProviderWithHistory from './components/common/auth0ProviderWithHistory/Auth0ProviderWithHistory';
import LoadingContainer from './components/common/loadingContainer/LoadingContainer';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import { ToastContainer } from 'react-toastify';
import { useAppSelector } from 'state/hooks';
import useSiteInitializer from 'components/hooks/useSiteInitializer';
import { AppRouter } from 'AppRouter';

const App = (): JSX.Element => {
    useSiteInitializer();

    const brandId = useAppSelector((s) => s.site.brandId);
    const brandSearchComplete = useAppSelector(
        (s) => s.site.brandSearchComplete
    );
    const clientId = useAppSelector((s) => s.site.clientId);
    const domain = useAppSelector((s) => s.site.domain);
    const audience = useAppSelector((s) => s.site.audience);
    const navigate = useNavigate();

    useEffect(() => {
        if (brandSearchComplete && brandId <= 0) {
            navigate(RoutePaths.GeneralError);
        }
    }, [brandSearchComplete]);

    return (
        <LoadingContainer loading={!brandSearchComplete} message={t('loading')}>
            <Auth0ProviderWithHistory
                clientId={clientId}
                domain={domain}
                audience={audience}>
                <AppRouter />
                <ToastContainer
                    position={'top-center'}
                    closeOnClick={true}
                    draggable={true}
                    theme='colored'
                />
            </Auth0ProviderWithHistory>
        </LoadingContainer>
    );
};

export default App;
